// extracted by mini-css-extract-plugin
export var headerCell = "_1p-1";
export var loadingStateCell = "_1p-4";
export var rowWrapper = "_1p-3";
export var standaloneTable = "_1p-5";
export var table = "_1p-0";
export var white = "_1p-2";